import { FC } from 'react';
import {
    Container,
    Flex,
    Box,
    VStack,
    Text,
    Image,
} from '@chakra-ui/react';

import './Contact.scss';

const Contact: FC = () => {
    return (
        <div className="Contact" data-testid="Contact">
            <Flex
                minH="50vh"
                alignItems="center"
                justifyContent="center"
                py={20}
                bg="color.500"
            >
                <Container maxW="1200px" w="100%">

                    <VStack
                        spacing={4}
                        align="flex-start"
                        textAlign="left"
                        mb={10}
                    >
                        <Text
                            fontSize={{ base: '2xl', md: '4xl' }}
                            fontWeight="bold"
                            color="white"
                            textTransform="uppercase"
                        >
                            Fale Conosco
                        </Text>
                        <Text fontSize={{ base: 'md', md: 'lg' }} color="white" maxW="600px">
                            Vamos dar vida às suas criações! Entre em contato e descubra soluções exclusivas que farão seu artesanato brilhar.
                        </Text>
                    </VStack>

                    <Flex
                        direction={{ base: 'column', md: 'row' }}
                        gap={10}
                        justify="center"
                        align={{ base: 'center', md: 'flex-start' }}
                    >

                        <Box flex="1" minW="300px" h="400px" borderRadius="md" overflow="hidden">
                            <iframe
                                title="Localização"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3689.705248735565!2d-51.4121651!3d-22.093994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9493f6980b8dfae7%3A0x24b127da7e790ff0!2sR.%20Maria%20Aparecida%20Cuissi%20Cesco%2C%20431%20-%20Parque%20Res.%20Jardins%2C%20Pres.%20Prudente%20-%20SP%2C%2019025-812!5e0!3m2!1spt-BR!2sbr!4v1724263032411!5m2!1spt-BR!2sbr"
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                allowFullScreen={false}
                                loading="lazy"
                            />
                        </Box>

                        <Box
                            flex="1"
                            minW="300px"
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                        >

                            <Box mb={10} textAlign="center">
                                <Image
                                    src={require("../../assets/img/logo-donna-cegonha.png")}
                                    alt="Logo Donna Cegonha"
                                    objectFit="contain"
                                    w="300px"
                                    h="120px"
                                />
                            </Box>

                            <Flex
                                direction={{ base: 'column', md: 'row' }}
                                w="100%"
                                maxW="600px"
                                justify="center"
                                align="stretch"
                                color="white"
                                fontSize="md"
                                textAlign="left"
                                gap={6}
                            >
                                <VStack spacing={4} align="flex-start" flex="1">
                                    <Box>
                                        <Text
                                            fontWeight="bold"
                                            mb={1}
                                            color="white"
                                            textTransform="uppercase"
                                        >
                                            Whatsapp Comercial
                                        </Text>
                                        <Text color="white">(18) 99164-6688</Text>
                                    </Box>
                                    <Box>
                                        <Text
                                            aria-label="Instagram"
                                            fontWeight="bold"
                                            mb={1}
                                            color="white"
                                            textTransform="uppercase"
                                        >
                                            Instagram
                                        </Text>
                                        <Text
                                            as="a"
                                            href="https://www.instagram.com/donna.cegonha_/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            color="white"
                                        >@donna.cegonha_</Text>
                                    </Box>
                                </VStack>

                                <Box
                                    display={{ base: 'none', md: 'block' }}
                                    w="2px"
                                    bg="color.neon"
                                    alignSelf="stretch"
                                />
                                <VStack spacing={4} align="flex-start" flex="1">
                                    <Box>
                                        <Text
                                            color="white"
                                            fontWeight="bold"
                                            mb={1}
                                            textTransform="uppercase"
                                        >
                                            Endereço
                                        </Text>
                                        <Text color="white">Rua Maria Aparecida Cuisse Cesco 431 - Casa 16, Presidente Prudente</Text>
                                    </Box>
                                    <Box>
                                        <Text
                                            color="white"
                                            fontWeight="bold"
                                            mb={1}
                                            textTransform="uppercase"
                                        >
                                            Email
                                        </Text>
                                        <Text color="white">daniella.gabi.ana@hotmail.com</Text>
                                    </Box>
                                </VStack>
                            </Flex>
                        </Box>
                    </Flex>
                </Container>
            </Flex>
        </div>
    );
};

export default Contact;
